import Reflux from 'reflux';

const PageActions = Reflux.createActions([
  'checkForQuiziframe',
]);

export default PageActions;



// WEBPACK FOOTER //
// ./src/js/actions/Page.js